// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__NV_PK","errorLogs":"EditorFooter_errorLogs__2SIzg"};